import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { REST_URL } from 'constants/index';
import ArticleAction, { ArticleTypes } from "redux/actions/articleAction";
import { getArticleByURLType, getTopThreeKnowledgeNews } from 'services/knowledgeServices';
import BaseAction from '../actions/baseAction';
import { RootState } from 'redux/store';
import { AppService } from 'services';
import { CONFIG } from '../../constants/configConstants';

const sortTopKbArticle = (articleData: any[], kbNumberList: string[]) => {
    const articleMap = new Map();
    const sortedTopKBList = [];

    for(const article of articleData) { 
      articleMap.set(article?.number, article);
    }

    for(const kbNumber of kbNumberList) {
      const article = articleMap.get(kbNumber);
      if(article) {
        sortedTopKBList.push(article);
        articleMap.delete(kbNumber);
      }
    } 

    for(const remainedArticle of articleMap.values()) {
      sortedTopKBList.push(remainedArticle);
    }
  return sortedTopKBList;
};

function yieldFeatureList(articles: any[], topArticleNumbers: string[]) {
  const featureList = topArticleNumbers && topArticleNumbers.length > 0
    ? sortTopKbArticle(articles, topArticleNumbers) 
    : articles;
  
  return put(ArticleAction.getListFeatureSuccess(featureList));
};

export function* getListAnnouncement(action: any): any {
  try {
    const url = REST_URL.ANNOUNCEMENT;
    const result = yield call(getArticleByURLType, url, action.params);
    yield put(ArticleAction.getListAnnouncementSuccess(result.data));
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_LIST_ANNOUNCEMENT ${error}`
    }));
  }
}

export function* getListFeature(action: any): any {
  try {
    const state: RootState = yield select();
    const { configReducer } = state;
    const { generalConfig } = configReducer;

    const { language = 'en' } = action?.params;
    const kbTopKey = CONFIG.KNOWLEDGE.KB_TOP;
    const topKbNumber = AppService.getKBNumber(generalConfig?.KbConfig, kbTopKey, language);
    const url = REST_URL.GET_ALL_FEATURE;
    const result = yield call(getArticleByURLType, url, action.params);
    yield yieldFeatureList(result.data, topKbNumber);
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_LIST_FEATURE ${error}`
    }));
  }
}

export function* getTopNews(action: any): any {
  try {
    const result = yield call(getTopThreeKnowledgeNews, action.params);
    yield put(ArticleAction.getTopNewsSuccess(result));      
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_TOP_NEWS ${error}`
    }));
  }
}

export function* getListMajorOutage(action: any): any {
  const { params } = action;
  const url = REST_URL.ANNOUNCEMENT;
  try {
    const result = yield call(getArticleByURLType, url, params);
    yield put(ArticleAction.getListMajorOutageSuccess(result.data));
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_LIST_MAJOR_OUTAGE ${error}`
    }));
  }
}

export const watchArticle = [
  takeEvery(ArticleTypes.GET_LIST_ANNOUNCEMENT, getListAnnouncement),
  takeEvery(ArticleTypes.GET_LIST_FEATURE, getListFeature),
  takeLatest(ArticleTypes.GET_TOP_NEWS, getTopNews),
  takeLatest(ArticleTypes.GET_LIST_MAJOR_OUTAGE, getListMajorOutage),
]